import './Contact.css';

function Contact() {
  return (
    <div className="contact">
      <h1>Contact</h1>
      <dl>
        <dt>Email</dt>
        <dd>
          <a href="mailto:kschmidfineart@gmail.com">kschmidfineart@gmail.com</a>
        </dd>
        <dt>Blog</dt>
        <dd>
          <a
            href="https://katieschmidfineart.blogspot.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            katieschmidfineart.blogspot.com
          </a>
        </dd>
      </dl>
    </div>
  );
}

export default Contact;
